import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTheme } from '../redux/state/themeState';

import moonImage from '../assets/moon.svg';
import sunImage from '../assets/sun.svg';

const ThemeToggle = () => {
    const dispatch = useDispatch();
    const theme = useSelector((state) => state.theme.theme);

    const toggleThemeHandler = () => {
        dispatch(toggleTheme());
    };

    return <StyledThemeToggle>
        {theme === 'light' && <img src={moonImage} alt='moon' onClick={toggleThemeHandler} />}
        {theme === 'dark' && <img src={sunImage} alt='sun' onClick={toggleThemeHandler} />}
    </StyledThemeToggle>;
};

const StyledThemeToggle = styled.div`
    position: fixed;
    z-index: 100;
    bottom: 2rem;
    right: 2rem;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${({ theme }) => theme.cardBg};
    box-shadow: ${({ theme }) => theme.cardShadowHover};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    img {
        width: 28px;
        height: 28px;
        transition: transform 0.3s ease;
    }
    
    &:hover {
        transform: scale(1.1) rotate(15deg);
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    }

    &:active {
        transform: scale(0.95);
    }

    @media(max-width: 540px) {
        bottom: 1rem;
        right: 1rem;
        width: 48px;
        height: 48px;
        
        img {
            width: 24px;
            height: 24px;
        }
    }
`;


export default ThemeToggle;
